export const breakfast1 = [
  {
    name: 'Egg Benedict',
    price: '$10',
    desc: 'English muffin, beef, hollandaise sauce, poached egg.',
  },
  {
    name: 'Texas Benedict',
    price: '$20',
    desc: 'English muffin, beef, hollandaise sauce, poached egg.',
  },
  {
    name: 'Rusty’s Omlette',
    price: '$30',
    desc: 'Mozzarella, cheddar, caramelized onion, black beans.',
  },
];

export const breakfast2 = [
  {
    name: 'Salmon Bagel',
    price: '$40',
    desc: 'Smoked salmon, cream cheese, dill, rocket, red onion.',
  },
  {
    name: 'Breakfast Bagel',
    price: '$50',
    desc: 'Chocolate, marshmallow, biscuit bar.',
  },
  {
    name: 'Rusty’s Pancake',
    price: '$60',
    desc: 'Strawberry, white chocolate, dark chocolate, crispearls.',
  },
];

export const dessert1 = [
  {
    name: 'Bourbon Pecan Pie',
    price: '$10',
    desc: 'Bourbon pecan stuffed pie, vanilla ice-cream.',
  },
  {
    name: 'New York Cheesecake',
    price: '$20',
    desc: 'Cheesecake, strawberry & lime salad.',
  },
  {
    name: 'Rusty’s ice-cream',
    price: '$30',
    desc: 'Vanilla, bourbon, cookie, chocolate ice-cream.',
  },
];

export const dessert2 = [
  {
    name: 'S’mores',
    price: '$40',
    desc: 'Chocolate chip cookies, marshmallow, chocolate.',
  },
  {
    name: 'Rocky Road',
    price: '$50',
    desc: 'Chocolate, marshmallow, biscuit bar.',
  },
  {
    name: 'Apple & Pear Crumble',
    price: '$60',
    desc: 'Caramelized pear, oat crumble, vanilla ice-cream.',
  },
];
export const starters1 = [
  {
    name: 'Mozzarella Dippers',
    price: '$10',
    desc: 'Fried mozzarella sticks, marinara sauce.',
  },
  {
    name: 'Onion Rings',
    price: '$20',
    desc: 'Fried onion rings, smoked aioli.',
  },
  {
    name: 'Fried Jalapeno',
    price: '$30',
    desc: 'Fried jalapeno pickles, cheddar sauce.',
  },
];

export const starters2 = [
  {
    name: 'Buffalo Wings',
    price: '$40',
    desc: 'Spicy chicken wings, blue cheese sauce, carrot, celery.',
  },
  {
    name: 'Chilli Con Carne',
    price: '$50',
    desc: 'Spicy ground beef, bacon, kidney beans.',
  },
  {
    name: 'Potato Skins',
    price: '$60',
    desc: 'Crispy potato skins; bacon & cheddar or vegetables.',
  },
];

export const steaks1 = [
  {
    name: 'SB Steak',
    price: '$10',
    desc: '1 lb of steak served with chips.',
  },
  {
    name: 'Cajun Fish Steak',
    price: '$20',
    desc: 'Cajun spicied seabass, deep fried baby potatoes.',
  },
  {
    name: 'Southern Fried Chicken',
    price: '$30',
    desc: 'Cajun coated chicken breast, fries and honey mustard.',
  },
];

export const steaks2 = [
  {
    name: 'Ribs',
    price: '$40',
    desc: 'Breaded crab cakes,   apple and fennel salad.',
  },
  {
    name: 'Smokehouse Combo',
    price: '$50',
    desc: 'Smoked beef brisket, rib and sausage, coleslaw.',
  },
  {
    name: 'Baby Back Ribs',
    price: '$60',
    desc: 'Bbq glazed baby   ribs, coleslaw, fries.',
  },
];
export const salads1 = [
  {
    name: 'Ceaser Salad',
    price: '$10',
    desc: 'Romaine lettuce, croutons, parmigiano, Ceaser dressing.',
  },
  {
    name: 'Waldorf Salad',
    price: '$20',
    desc: 'Lettuce, celery, apple, grape, walnut, waldorf sauce.',
  },
  {
    name: 'Quinoa & Avocado  ',
    price: '$30',
    desc: 'Quinoa, avocado, mixed greens. Nuts, fresh fruits.',
  },
];

export const salads2 = [
  {
    name: 'Grilled Salmon Salad',
    price: '$40',
    desc: 'Grilled salmon, mixed greens, capers, orange slices.',
  },
  {
    name: 'Chicken Cobb Salad',
    price: '$50',
    desc: 'Iceberg  blue cheese, avocado.',
  },
  {
    name: 'Salad Chicken',
    price: '$60',
    desc: 'Ceaser dressing. Optional grilled chicken breast.',
  },
];

export const appetizers1 = [
  {
    name: 'Risotto  Carciofi',
    price: '$10',
    desc: 'Risotto with scampi and artichokes.',
  },
  {
    name: 'Carpaccio  Parmesan',
    price: '$20',
    desc: 'Finely sliced raw beef with rocket and parmesan cheese.',
  },
  {
    name: 'Insalata  Parmesan',
    price: '$30',
    desc: ' Finely sliced raw art ket lettuce topped with parmesan cheese.',
  },
];
export const appetizers2 = [
  {
    name: ' S`Jacques',
    price: '$40',
    desc: 'Scallops and mixed shellfish with creamy fish sauce au gratin.',
  },
  {
    name: ' Verdure',
    price: '$50',
    desc: 'Grilled seasonal vegetables and garlic bread.',
  },
  {
    name: 'Bruschetta',
    price: '$60',
    desc: 'Diced tomato, olive oil, garlic and fresh basil on toast.',
  },
];

export const burgers1 = [
  {
    name: ' California Burger',
    price: '$10',
    desc: 'A half ground bacon, half ground beef burger patty  .',
  },
  {
    name: 'Texas Smokehouse',
    price: '$20',
    desc: 'Prepared with  onion  then grilled.',
  },
  {
    name: 'Angus Burger',
    price: '$30',
    desc: 'A hamburger made using beef from Angus cattle. ',
  },
];
export const burgers2 = [
  {
    name: 'Barbeque Burger',
    price: '$40',
    desc: 'Prepared with ground bee ce, and then grilled.',
  },
  {
    name: 'Salmon Burger',
    price: '$50',
    desc: 'A fishcake  salmon in the style of a hamburger.',
  },
  {
    name: 'Veggie Burger',
    price: '$60',
    desc: 'A veggie bur t  ed vegetable protein .',
  },
];

export const drinks1 = [
  {
    name: 'Cola',
    price: '$10',
    desc: 'classic cola.',
  },
  {
    name: 'Diet Cola',
    price: '$20',
    desc: 'diet cola.',
  },
  {
    name: 'Water',
    price: '$30',
    desc: 'Water, served with glass bottle.',
  },
];
export const drinks2 = [
  {
    name: 'Apple Juice',
    price: '$40',
    desc: 'Fresh pressed apple juice.',
  },
  {
    name: 'Mix Juice',
    price: '$50',
    desc: 'A mixture of seasonal fruits.',
  },
  {
    name: 'Mineral Water',
    price: '$60',
    desc: 'Mineral water served with glass bottle.',
  },
];
